import React from 'react';
import './style.scss'

const PrimaryInput = ({ value, label, name, onChange, placeholder, halfWidth, textarea }) => {
    return (
        <div className={`primary__input__container ${halfWidth ? "half__width" : ""}`}>
            <p>
                {label}
            </p>
            {textarea ?
                <textarea rows={4} name={name} value={value} onChange={onChange} placeholder={placeholder} />
                : <input name={name} value={value} onChange={onChange} placeholder={placeholder} />}
        </div>
    )
}

export default PrimaryInput